import React, { ReactChildren } from 'react'

interface Props {
  isConfirmationModalOpened: boolean
  close: () => void
  formSubmitCallback: () => boolean
  children?: ReactChildren | string
  title: JSX.Element | string
}

export const AuthenticCheckModal: React.FunctionComponent<Props> = ({
  isConfirmationModalOpened,
  close,
  formSubmitCallback,
  title,
  children,
}) => (
  <>
    <div
      className={`modal fade ${isConfirmationModalOpened && 'in fadeInAnimation animated'}`}
      tabIndex={-1}
      role="dialog"
      aria-labelledby="confirmation-modal"
      aria-hidden="true"
      style={isConfirmationModalOpened ? { display: 'block' } : {}}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">{title}</h3>
          </div>
          <div className="modal-body">
            {children}
            <br />
            <button
              className="btn btn-default dw-btn"
              id="modal-btn"
              onClick={() => {
                close()
                formSubmitCallback()
              }}
            >
              OK
            </button>
            <button
              className="btn btn-default dw-btn"
              id="modal-btn-cancel"
              onClick={() => {
                close()
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    {isConfirmationModalOpened && <div className="modal-backdrop fade in" />}
  </>
)
